"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    label: 'Upload files',
    buttonLabel: 'Choose files',
    dismissButtonLabel: 'Remove file',
    wrongFileType: 'The selected file must be a %{fileType}.',
    allowedFileTypes: 'Allowed file types: %{fileTypes}.',
    fileTooBig: 'The selected file must be smaller than %{size}MB.',
    fileIsEmpty: 'The selected file is empty.',
    problemUploading: 'The selected file could not be uploaded. Try again.',
    problemDeleting: 'The selected file could not be deleted. Try again.',
    problemUploadingMultipleFiles: 'The selected files could not be uploaded. Try again.',
    only: 'only',
    and: 'and',
    or: 'or',
    uploadSuccess: 'uploaded successfully.',
    uploadError: 'was not uploaded due to',
    deleteProblem: 'was not deleted due to',
    tooManyFiles: 'You can only select up to %{maxFilesCount} files at the same time.',
    fileTooSmall: 'The selected file must be at least %{size}MB.',
    fewFiles: 'You must select at least %{minFilesCount} files.'
  },
  fr: {
    label: 'Téléverser les fichiers"',
    buttonLabel: 'Choisir les fichiers',
    dismissButtonLabel: 'Supprimer le fichier',
    wrongFileType: 'Le fichier sélectionné doit être au format %{fileType}.',
    allowedFileTypes: 'Formats de fichiers autorisés : %{fileTypes}.',
    fileTooBig: 'Le fichier sélectionné doit être inférieur à %{size}Mo.',
    fileIsEmpty: 'Le fichier sélectionné est vide.',
    problemUploading: 'Impossible de téléverser le fichier sélectionné. Veuillez réessayer.',
    problemDeleting: `Le fichier sélectionné n'a pas pu être supprimé. Réessayez.`,
    problemUploadingMultipleFiles: `Les fichiers sélectionnés n'ont pas pu être téléchargés. Veuillez réessayer.`,
    only: 'uniquement',
    and: 'et',
    or: 'ou',
    uploadSuccess: 'téléchargé avec succès.',
    uploadError: `n'a pas été téléchargé en raison de`,
    deleteProblem: `n'a pas été supprimé en raison de`,
    tooManyFiles: `Vous ne pouvez sélectionner que jusqu'à %{maxFilesCount} fichiers en même temps.`,
    fileTooSmall: `Le fichier sélectionné doit faire au moins %{size}Mo.`,
    fewFiles: `Vous devez sélectionner au moins %{minFilesCount} fichiers.`
  }
};